import { createBrowserRouter } from "react-router-dom";

import AppLayout from "@layouts/AppLayout";
import LoginLayout from "@layouts/LoginLayout";
import Store from "@pages/store";
import Cart from "@pages/cart";
import Wallet from "@pages/wallet";
import Login from "@pages/login";
import Register from "@pages/register";
import Verify from "@pages/verify";
import Dashboard from "@pages/dashboard";
import Orders from "@pages/orders";
import AppLayoutWallet from "@layouts/AppLayoutWallet";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "",
        element: <Store />,
      },
      {
        path: "cart",
        element: <Cart />,
      },
      {
        path: "orders",
        element: <Orders />,
      },
      {
        path: "settings",
        element: <div>SETTINGS</div>,
      },
    ],
  },
  {
    path: "/wallet",
    element: <Wallet />,
  },
  {
    path: "/",
    element: <LoginLayout />,
    children: [
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "verify",
        element: <Verify />,
      },
    ],
  },
  {
    path: "/",
    element: <AppLayoutWallet />,
    children: [
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
    ],
  },
]);
